import { Outlet, Link, Navigate, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useRefreshMutation } from "./authApiSlice";
import { useSelector } from "react-redux";
import { selectCurrentToken } from "./authSlice";
import { PiArrowFatRightDuotone } from "react-icons/pi";
import { FaArrowAltCircleRight } from "react-icons/fa";
import LoadingIndicator from "../../components/BasicComponents/LoadingIndicator";
import ErrorPage from "./ErrorPage";

const PersistLogin = () => {
  const persist = true;
  const location = useLocation();
  const token = useSelector(selectCurrentToken);
  const effectRan = useRef(false);
  const [trueSuccess, setTrueSuccess] = useState(false);
  const [refresh, { isUninitialized, isLoading, isSuccess, isError, error }] =
    useRefreshMutation();
  useEffect(() => {
    if (effectRan.current === true || process.env.NODE_ENV !== "development") {
      // React 18 Strict Mode
      const verifyRefreshToken = async () => {
        console.log("verifying refresh token");
        try {
          //const response =
          await refresh();
          //const { accessToken } = response.data /home/vizlabs/viz labs/viztaReactApp/viztaFrontendDave/.env
          setTrueSuccess(true);
        } catch (err) {
          console.error(err);
        }
      };
      if (!token && persist) verifyRefreshToken();
    }
    return () => (effectRan.current = true);
    // eslint-disable-next-line
  }, []);

  let content;
  if (!persist) {
    // persist: no
    content = <Outlet />;
  } else if (isLoading) {
    //persist: yes, token: no

    // content = <PulseLoader color={"#FFF"} />;
    content = <LoadingIndicator />;
  } else if (isError) {
    //persist: yes, token: no
    console.log(error);
    content = <Navigate to="/login" state={{ from: location }} replace />;
  } else if (isSuccess && trueSuccess) {
    //persist: yes, token: yes
    console.log("success");
    content = <Outlet />;
  } else if (token && isUninitialized) {
    //persist: yes, token: yes
    console.log("token and uninit");
    console.log(isUninitialized);
    content = <Outlet />;
  }

  return content;
};
export default PersistLogin;
